import Main from './Main'
import Lista from './components/TipoRemocaoLista'
import Novo from './components/NovoTipoRemocao'

export default [
  {
    path: 'tipo-remocao',
    name: 'policiacivil.processo.tipo-remocao',
    component: Main,
    redirect: { name: 'policiacivil.processo.tipo-remocao.list' },
    children: [
      {
        path: '/',
        name: 'policiacivil.processo.tipo-remocao.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'policiacivil.processo.tipo-remocao.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'policiacivil.processo.tipo-remocao.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/processo/tipo-remocao/routes.js